// extracted by mini-css-extract-plugin
module.exports = {"container":"LastMatchTile_container__2JA5Q","tournamentName":"LastMatchTile_tournamentName__39dke","desc":"LastMatchTile_desc__3D0HD"};